var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionsBusFilledOutlinedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#84888d",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1878",
    "data-name": "Groupe 1878",
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1864",
    "data-name": "Groupe 1864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_585",
    "data-name": "Trac\\xE9 585",
    d: "M8,0C4,0,0,.5,0,4v9.5a3.464,3.464,0,0,0,1,2.44V18a1,1,0,0,0,1,1H3a1,1,0,0,0,1-1V17h8v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V15.94a3.464,3.464,0,0,0,1-2.44V4c0-3.5-3.58-4-8-4M8,2c3.71,0,5.13.46,5.67,1H2.43C3.03,2.48,4.48,2,8,2m6,11a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V10H14Zm0-5H2V5H14Z",
    fill: "#84888d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_586",
    "data-name": "Trac\\xE9 586",
    d: "M4.5,14A1.5,1.5,0,1,0,3,12.5,1.5,1.5,0,0,0,4.5,14",
    fill: "#84888d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_587",
    "data-name": "Trac\\xE9 587",
    d: "M11.5,14A1.5,1.5,0,1,0,10,12.5,1.5,1.5,0,0,0,11.5,14",
    fill: "#84888d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsBusFilledOutlinedGrey);
export default __webpack_public_path__ + "static/media/DirectionsBusFilledOutlinedGrey.a36254364d8d8c671fad4d3fadb3c8d1.svg";
export { ForwardRef as ReactComponent };